import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-coupon-usage-dialog',
  templateUrl: './coupon-usage-dialog.component.html',
  styleUrl: './coupon-usage-dialog.component.scss',
  standalone: false,
})
export class CouponUsageDialogComponent {
  public redeemedBy: any[];
  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig
  ) {
    this.redeemedBy = this.dialogConfig.data.redeemedBy;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
